module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 npd novedades__bloque"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 npd novedades__categoria"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [(_vm.cat_icon) ? _c('i', {
    staticClass: "icon",
    style: ('background-image: url(' + _vm.cat_icon + ')')
  }) : _vm._e(), _vm._v("\n\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.categoria) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cat',
        params: {
          name: _vm.slug
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVer todo >\n\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs 12"
  }, _vm._l((_vm.noticias), function(noticia) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: noticia.slug
          }
        }
      }
    }, [(noticia.better_featured_image !== null) ? _c('figure', [_c('img', {
      attrs: {
        "src": noticia.better_featured_image.media_details.sizes['536x516'].source_url,
        "alt": ""
      }
    })]) : (noticia.featured_image_src['full'][0]) ? _c('figure', [_c('img', {
      attrs: {
        "src": noticia.featured_image_src['full'][0],
        "alt": ""
      }
    })]) : _c('figure', [_c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/novedad.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(noticia.title.rendered)
      }
    })])], 1)
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fea5aac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoriaportada.vue
// module id = 130
// module chunks = 0